export const printList = [
    {
        label: '配送单-标准',
        value: 'tms_psd_custNo',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '配送单(订单维度)',
        value: 'tms_psd_tp',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '出库单-小米',
        value: 'tms_ckd_xiaomi',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '集配单-小米',
        value: 'tms_jpd_xiaomi',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '集配小单',
        value: 'tms_jpxd_custNo',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '集配单-扫码到车',
        value: 'tms_jpd',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '提货单',
        value: 'tms_pickup',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '网点配送单',
        value: 'tms_psd_net',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '分拨交接单',
        value: 'tms_handover_allocate',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '电商退货交接单',
        value: 'tms_handover_ri',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '送货清单',
        value: 'tms_consignment',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '提货清单',
        value: 'tms_pickup_list',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '海信物流发货单',
        value: 'tms_fhd_hisense',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '配送单-沱牌舍得',
        value: 'tms_psd_tpsd',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '配送单-管家婆',
        value: 'tms_psd_order',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '视源物流签收单',
        value: 'tms_sign_cvte',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '电子面单',
        value: 'tms_electronic_bill',
        printType: 'urlPrint',
        expose: true
    },
    {
        label: '运输协议',
        value: 'tms_protocol_transport_old',
        printType: 'transportPrint',
        expose: true
    },
    {
        label: '运输协议(新)',
        value: 'tms_protocol_transport',
        printType: 'transportPrint',
        expose: true
    },
    {
        label: '配送单-凌云(怡惠龙)',
        value: 'tms_psd_ly',
        printType: 'urlPrint'
    },
    {
        label: '装车单',
        value: 'tms_loading',
        printType: 'urlPrint'
    },
    {
        label: '配送单-协同',
        value: 'tms_psd_xietong',
        printType: 'urlPrint'
    },
    {
        label: '家居配送单(分拨)',
        value: 'tms_jjpsd_allocate',
        printType: 'urlPrint'
    },
    {
        label: '配送单-鸿合',
        value: 'tms_psd_honghe',
        printType: 'urlPrint'
    },
    {
        label: '家居运输交接单',
        value: 'tms_ysjjd_jiaju',
        printType: 'urlPrint'
    },
    {
        label: '家居配送单(客户)',
        value: 'tms_jjpsd_customer',
        printType: 'urlPrint'
    },
    {
        label: '配送单-鲁花',
        value: 'tms_psd_luhua',
        printType: 'urlPrint'
    },
    {
        label: '配送单-博宜通',
        value: 'tms_psd_byt',
        printType: 'urlPrint'
    },
    {
        label: '苏泊尔-配送单(统配)',
        value: 'tms_psd_sbe',
        printType: 'urlPrint'
    },
    {
        label: '配送单-农夫山泉',
        value: 'tms_psd_nfsq',
        printType: 'urlPrint'
    },
    {
        label: '视源海信客制物流签收单',
        value: 'tms_customer_cvte',
        printType: 'urlPrint'
    },
    {
        label: '配送单（汇总）-博宜通',
        value: 'tms_psd_bythz',
        printType: 'urlPrint'
    },
    {
        label: '配送单-海康威视',
        value: 'tms_psd_hkws',
        printType: 'urlPrint'
    },
    {
        label: '出库单',
        value: 'tms_outbound',
        printType: 'ckdPrint'
    },
    {
        label: '配送单-奈雪',
        value: 'tms_psd_nx',
        printType: 'nxPrint'
    },
    {
        label: '配送单-奈雪2B',
        value: 'tms_psd_nx_2B',
        printType: 'nxPrint'
    },
    {
        label: '配送单-蓝月亮',
        value: 'tms_psd_bluemoon',
        printType: 'bluemoonPrint'
    },
    {
        label: '配送单(订单维度)(新)',
        value: 'tms_psd_tp_new',
        printType: 'urlPrint'
    },
    {
        label: '配送单(新隆)',
        value: 'tms_psd_xl',
        printType: 'urlPrint'
    },
    {
        label: '配送单管家婆2.0',
        value: 'tms_psd_kx',
        printType: 'urlPrint'
    },
    {
        label: '集配单',
        value: 'tms_jpd_old',
        printType: 'urlPrint'
    },
    {
        label: '发车单汇总',
        value: 'tms_psd_xl_summary',
        printType: 'urlPrint'
    },
    {
        label: '装车单-配送单',
        value: 'tms_zcd_psd_summary',
        printType: 'urlPrint'
    },
    {
        label: '装车单-送货单',
        value: 'tms_zcd_shd_summary',
        printType: 'urlPrint'
    },
    {
        label: '2C直配送货清单',
        value: 'tms_2c_shqd',
        printType: 'urlPrint'
    },
    {
        label: '配送单-华申',
        value: 'tms_psd_hs',
        printType: 'urlPrint'
    },
    {
        label: '配送单-九牧',
        value: 'tms_psd_jm',
        printType: 'urlPrint'
    },
    {
        label: '提货清单-退货',
        value: 'tms_thqd_th',
        printType: 'urlPrint'
    },
    {
        label: '配送单(关联交易主体专用)',
        value: 'tms_psd_connect_trade',
        printType: 'urlPrint'
    },
    {
        label: '配送单-永和豆浆',
        value: 'tms_psd_yhdj',
        printType: 'urlPrint'
    },
    {
        label: '送货单(便利小二A4竖版)',
        value: 'tms_shd_blxe',
        printType: 'urlPrint'
    },
    {
        label: '配送单-三养',
        value: 'tms_psd_sy',
        printType: 'urlPrint'
    },
    {
        label: '快消配送单',
        value: 'tms_psd_mdd',
        printType: 'urlPrint'
    },
    {
        label: '快消退货单',
        value: 'tms_thd_mdd',
        printType: 'urlPrint'
    },
    {
        label: '柠檬共和国配送单',
        value: 'tms_psd_lemon',
        printType: 'urlPrint'
    },
    /* 基地排车单据打印 */
    {
        label: '提货单-基地',
        value: 'tms_pickup_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk' // 折叠类型
    },
    {
        label: '提货单（未发订单）-基地',
        value: 'tms_pickup_unshipped_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk' // 折叠类型
    },
    {
        label: '配送单-基地',
        value: 'tms_psd_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '提货单明细-基地',
        value: 'tms_pickup_list_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '运输标签-基地',
        value: 'tms_label_transport_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '送货清单-基地',
        value: 'tms_consignment_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '运输协议-旧',
        value: 'tms_protocol_transport_old_trunk',
        printType: 'transportPrint',
        collapseType: 'trunk'
    },
    {
        label: '运输协议-新',
        value: 'tms_protocol_transport_trunk',
        printType: 'transportPrint',
        collapseType: 'trunk'
    },
    {
        label: '装车单-菜鸟',
        value: 'tms_loading_cainiao',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '送货清单-直发',
        value: 'tms_consignment_zf_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '下线直发拣货单',
        value: 'tms_picking_offline_zf',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '电商退货交接单',
        value: 'tms_handover_ri_trunk',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '京东运输委托书',
        value: 'tms_mandate_transport_jd',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '零担合同',
        value: 'tms_consignment_lcl',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '送货清单-基地简化版',
        value: 'tms_consignment_trunk_jh',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '送货清单-基地无扫码版',
        value: 'tms_consignment_trunk_noscan',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '送货清单-基地(集拼单维度)',
        value: 'tms_consignment_trunk_jp',
        printType: 'urlPrint',
        collapseType: 'trunk'
    },
    {
        label: '送货清单-楼宇专用',
        value: 'tms_consignment_trunk_building',
        printType: 'urlPrint',
        collapseType: 'trunk'
    }
];
